import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

interface RichTextRendererProps {
  htmlString: string;
  className?: string;
}

export function RichTextRenderer({ htmlString, className = '' }: RichTextRendererProps) {
  if (!htmlString) {
    return null;
  }

  const cleanHtml = DOMPurify.sanitize(htmlString, {
    // Stops some unwanted styles
    FORBID_TAGS: ['font'],
    FORBID_ATTR: ['style'],
  });

  return <div className={className}>{parse(cleanHtml)}</div>;
}
